import React from 'react';
import className from 'classnames/bind';
import styles from 'components/card-item-group/index.module.scss';
import Icon from 'components/icon';
import arrow from 'assets/icon_cad_arrow.svg';
const cx = className.bind(styles);

const CardItem = ({ dataItem = {} }) => {
  const cardItemClasses = cx({
    'card-item': true,
    alert: dataItem.alert,
  });

  return (
    <div className={cardItemClasses} onClick={dataItem.onClick}>
      <div className={styles['icon-content']}>
        {dataItem.icon ? <Icon imgSrc={dataItem.icon} height="24px" alt="icon" /> : ''}
      </div>
      <div className={styles.content}>
        {dataItem.content}
        {dataItem.alert ? <div className={styles['alert-dot']} /> : ''}
      </div>
      <div className={styles['right-content']}>{dataItem.rightContent}</div>
      {dataItem.withArrow && <img className={styles.arrow} src={arrow} alt="arrow" />}
    </div>
  );
};

const CardItemGroup = ({ data = [] }) => {
  return data.map(dataItem => {
    return <CardItem dataItem={dataItem} key={dataItem.id} />;
  });
};

export default CardItemGroup;
